import { render } from "./Immunization.vue?vue&type=template&id=0d3484dd"
import script from "./Immunization.ts?vue&type=script&lang=js&external"
export * from "./Immunization.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__